// extracted by mini-css-extract-plugin
export default {"message":"default_message__fEYJ3","message__content":"default_message__content__A6cff","message__controls":"default_message__controls__0Pp06","button":"default_button__+4Wsa"};